import api from '@/lib/api/axios'

export interface PopulatePermissionsResponse {
    success: boolean
    data: {
        message: string
        permissionsCreated: number
        permissionsUpdated: number
        roleLinksCreated: number
        roleLinksSkipped: number
        rolesProcessed: Array<{
            roleName: string
            assigned: number
            skipped: number
        }>
    }
    message: string
}

export const adminApi = {
    populatePermissions: () =>
        api.post<PopulatePermissionsResponse>('/api/admin/populate-permissions'),
    getRetentionDefaults: () =>
        api.get<RetentionDefaultsResponse>('/api/admin/retention-defaults'),
    updateRetentionDefaults: (payload: { vault?: number; object?: number }) =>
        api.put<RetentionDefaultsResponse>('/api/admin/retention-defaults', payload),
}

export interface RetentionDefaults {
    vault: number
    object: number
    objectMax: number
}

export interface RetentionDefaultsResponse {
    success: boolean
    data: RetentionDefaults
}
